import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
	selector: 'address-price-modal',
	templateUrl: './address-price-modal.component.html',
	styleUrls: ['./address-price-modal.component.scss'],
})
export class AddressPriceModalComponent implements OnChanges {
	@Input() isOpen;
	@Input() action: 'create' | 'edit' = 'create';
	@Input() step = 0;
	@Input() price = 0;
	@Output() onClose = new EventEmitter();
	@Output() onSave = new EventEmitter();

	priceCtrl = null;
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.action) {
			this.step = changes.action.currentValue === 'edit' ? 0 : 1;
		}
		if (changes.price) {
			this.priceCtrl = new FormControl(this.price, Validators.min(0));
		}
	}

	leftButtonModal() {
		if (this.step === 0) {
			this.onClose.emit();
		} else if (this.step === 1) {
			this.step = 0;
		}
	}

	rightButtonModal() {
		if (this.step === 0) {
			this.step = 1;
		} else if (this.step === 1) {
			this.save();
		}
	}

	save() {
		if (this.priceCtrl.valid) {
			this.onSave.emit(this.priceCtrl.value);
			this.onClose.emit();
		}
	}
}
